
import { post } from 'store/http/httpAction';
import _ from 'lodash';
import { notification } from 'antd';
import moment from 'moment';
import Enums from 'utils/EnumsManager';
import { setStore, removeStore } from 'utils/localStorage';
import { fetchLoginUserDetail } from 'store/global/action';
import { addError } from 'store/error/action';
import allInfos from 'i18n/global/info';
import {
  LOGOUT_SUCCESS,
  DEREGISTER_LOGIN_USER,
} from './actionTypes';

const { LocalStorageKeys } = Enums;
const { User } = LocalStorageKeys;

export const deRegisterLoginUser = path => ({
  type: DEREGISTER_LOGIN_USER,
  payload: { path },
});
const logoutSuccess = json => ({
  type: LOGOUT_SUCCESS,
  payload: { json },
});

export const tryLogin = (values, successMessage, getUpdatePasswordMessage, cb) => dispatch => post('/admin/login', values, dispatch, { successMessage, callbackAction: (requestResult) => cb(requestResult) })
  .then((json) => {
    if (_.isFunction(cb)) {
      cb();
    }
    if (json) {
      if (json.data && json.data.token_info) {
        setStore(User, {
          token_info: json.data.token_info
        });

        const passwordUpsertedAt = json.data.password_changed_at || json.data.created_at;
        const passwordExpiresDays = json.data.password_expires_days;

        // if passwordExpiresDays === -1 means unlimited, hence no need to check password expiry
        if (passwordExpiresDays !== -1 && passwordUpsertedAt) {
          // date the password will expire
          const passwordExpiration = moment(passwordUpsertedAt).startOf('day').add(passwordExpiresDays, 'days');
          // days between today and password expire date
          const timeDeltaInDays = passwordExpiration.startOf('day').diff(moment().startOf('day'), 'days');
          if (timeDeltaInDays <= 30) {
            dispatch(addError(getUpdatePasswordMessage(timeDeltaInDays)));
            if (timeDeltaInDays <= 3) {
              setTimeout(() => {
                window.location.replace('/my-setting');
              }, 5000);
            }
          }
        }
      }
      dispatch(fetchLoginUserDetail())
        .then((isFetched) => {
          if (isFetched) return;
          removeStore(User);
          notification.error({
            message: allInfos[window.globalLanguage].networkError,
          });
        })
        .catch(() => {
          removeStore(User);
        });
    }
  });

export const tryLogout = successMessage => dispatch => post('/admin/logout', {}, dispatch, { successMessage }).then(() => {
  dispatch(logoutSuccess());
});




// WEBPACK FOOTER //
// ./src/views/LoginForm/flow/actions.js